import React, { useEffect, useState } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer } from 'react-toastify';
import { formatDate } from '../../Global/Index';
import PropTypes from 'prop-types'; 
import { useTheme } from "@mui/material";


const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '44%',
    coerce: true
};

export default function LoanTimeLine({ history }) {
    const [transformedTimeline, setTransformedTimeline] = useState(null);
    const theme = useTheme();

    useEffect(() => {
        const transformedTimelineval = [];
        for (const [key, value] of Object.entries(history)) {
            if (value !== null && value !== undefined && value !== '') {
                if (key === "Disbursementdate") {
                    transformedTimelineval.push({ service_name: "Disbursement Date", value: value });
                } else {
                    const formattedKey = key.replace(/([A-Z])/g, ' $1').trim();
                    transformedTimelineval.push({ service_name: formattedKey, value: value });
                }
            }
        }

        // Sorting array by date (assuming value holds date strings in "YYYY-MM-DD" format)
        transformedTimelineval.sort((a, b) => new Date(a.value) - new Date(b.value));
        transformedTimelineval.reverse(); // Reverse to show the most recent date first

        setTransformedTimeline(transformedTimelineval);
    }, [history]);

    const colors = ['b-danger', 'b-primary', 'b-warning', 'b-success', 'b-info'];

    const renderloantimeline = () => {
        const limit = transformedTimeline.length;
        return transformedTimeline.slice(0, limit).map((event, index) => {
            const colorIndex = Math.floor(index / 2) % colors.length;
            const colorClass = colors[colorIndex];
            const isActive = index === 0 ? 'active' : '';

            return (
                <div key={index+1} className={`tl-itemm ${isActive}`}>
                    <div className={`tl-dot ${colorClass}`}></div>
                    <div className="tl-content" style={{ lineHeight: '1.3rem', marginLeft: '1vw' }}>
                        <div>{event.service_name}</div>
                        <div>{event.value !== null ? formatDate(event.value) : 'No date found'}</div>
                    </div>
                </div>
            );
        });
    };

    const renderLoanTimelineContent = () => {
        if (!transformedTimeline) {
            return (
                <ClipLoader
                    color={theme.palette.maincolor.light}
                    loading={true}
                    cssOverride={override}
                    size={30}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            );
        }

        if (transformedTimeline.length > 0) {
            return renderloantimeline();
        } else {
            return <p style={{ textAlign: 'center' }}>No Loan Timeline Found</p>;
        }
    };

    return (
        <>
            <ToastContainer />
            <div>
                <div className='loantimeline'>
                    <h3>Loan Timeline</h3>
                    {renderLoanTimelineContent()}
                </div>
            </div>
        </>
    );
}

// PropTypes validation
LoanTimeLine.propTypes = {
    history: PropTypes.object.isRequired
};